import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList,
  GraphQLString,
  GraphQLInt
} from 'graphql'
import { mapLibraryFilters } from '../endpoint-helpers'
import { ContrastGraphQLFieldConfig } from '..'
import {
  GenericMutationResponse,
  GenericMutationResponseType
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  LibraryFilterArg,
  libraryFilterArgType
} from '../types/library-filter-arg'

export const deleteServerLibrariesWithFilters: ContrastGraphQLFieldConfig<
  undefined,
  Context,
  {
    readonly input?: {
      readonly filters: LibraryFilterArg
      readonly organizationID: string
      readonly libraryHashesToExclude: string[]
      readonly serverID: number
    }
  },
  GenericMutationResponse
> = {
  description: 'Delete one or more server libraries via filters',
  type: GenericMutationResponseType,
  args: {
    input: {
      type: new GraphQLInputObjectType({
        name: 'DeleteServerLibrariesByFiltersMutationArg',
        fields: {
          organizationID: {
            description:
              'The ID of the organization of the server libraries being deleted',
            type: new GraphQLNonNull(GraphQLID)
          },
          filters: {
            type: new GraphQLNonNull(libraryFilterArgType)
          },
          libraryHashesToExclude: {
            description: 'A list of library hashes to exclude from the filters',
            type: new GraphQLNonNull(new GraphQLList(GraphQLString))
          },
          serverID: {
            type: new GraphQLNonNull(GraphQLInt)
          }
        }
      })
    }
  },
  async resolve(_source, args, { connector }) {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }

    const { filters, organizationID, libraryHashesToExclude, serverID } =
      args.input

    await connector.executeDelete(
      `${organizationID}/servers/${serverID}/libraries/filters`,
      {
        ...mapLibraryFilters(filters),
        libraryHashesToExclude
      }
    )

    return {
      _placeholder: true
    }
  }
}
